import React, { createContext, useCallback, useContext, useEffect, useState, } from 'react';
import useMutableValue, { mutableValuePlaceholder, } from '@polestar/component-warehouse-react/hooks/useMutableValue';
const noProviderFunction = (handleName) => () => {
    console.warn(`Trying to use drawer context consumer, but no context provider for "${handleName}". Please make sure you use the useNavigationDrawer inside a <PolestarApp /> or check if there are multiple @polestar/component-warehouse-react versions installed due to (for example) shared modules hard dependencies.`);
};
/**
 * @internal
 */
export const NavigationDrawerContext = createContext({
    /**
     * @internal
     */
    navigationDrawerOpen: mutableValuePlaceholder(false),
    toggleNavigationDrawer: noProviderFunction('toggleNavigationDrawer'),
    openNavigationDrawer: noProviderFunction('openNavigationDrawer'),
    closeNavigationDrawer: noProviderFunction('closeNavigationDrawer'),
});
export const useNavigationDrawer = () => useContext(NavigationDrawerContext);
export const useIsNavigationDrawerOpen = () => {
    const { navigationDrawerOpen } = useContext(NavigationDrawerContext);
    const [isNavigationDrawerOpen, setIsNavigationDrawerOpen] = useState(navigationDrawerOpen.get());
    useEffect(() => {
        navigationDrawerOpen.on('change', setIsNavigationDrawerOpen);
        return () => {
            setIsNavigationDrawerOpen(false);
        };
    }, [navigationDrawerOpen]);
    return isNavigationDrawerOpen;
};
/**
 * @internal
 */
export const NavigationDrawerProvider = ({ children }) => {
    const navigationDrawerOpen = useMutableValue(false);
    const [navigationDrawerExpanded, setNavigationDrawerExpanded] = useState(false);
    const [navigationDrawerId, setNavigationDrawerId] = useState('');
    const openNavigationDrawer = useCallback(() => {
        navigationDrawerOpen.set(true);
        setNavigationDrawerExpanded(true);
    }, [navigationDrawerOpen]);
    const closeNavigationDrawer = useCallback(() => {
        navigationDrawerOpen.set(false);
        setNavigationDrawerExpanded(false);
    }, [navigationDrawerOpen]);
    const toggleNavigationDrawer = useCallback(() => {
        navigationDrawerOpen.set(!navigationDrawerOpen.get());
    }, [navigationDrawerOpen]);
    return (React.createElement(NavigationDrawerContext.Provider, { value: {
            navigationDrawerOpen,
            openNavigationDrawer,
            closeNavigationDrawer,
            toggleNavigationDrawer,
            navigationDrawerExpanded,
            setNavigationDrawerId,
            navigationDrawerId,
        } }, children));
};
